export const ACCORDION_SX = {
  '&:before': { display: 'none' },
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  '&:not(:last-child)': { marginBottom: 1 },
  boxShadow: 'none',
  overflow: 'hidden',
};

export const ACCORDION_SUMMARY_SX = {
  px: 2,
  py: 1.5,
  minHeight: 'unset',
  backgroundColor: 'background.paper',
  borderBottom: '1px solid',
  borderColor: 'divider',
  '&.Mui-expanded': {
    minHeight: 'unset',
  },
  '& .MuiAccordionSummary-content': {
    alignItems: 'center',
    gap: 1,
    m: 0,
    '&.Mui-expanded': {
      m: 0,
    },
  },
  '&.Mui-focusVisible': {
    bgcolor: 'action.hover',
    boxShadow: 'none',
  },
};

export const ACCORDION_DETAILS_SX = {
  p: 2,
  backgroundColor: 'background.paper',
};
